import { useEffect, useState } from 'react'

// Mismo breakpoint que los `@media (min-width: 768px)` de los CSS modules. Solo para los casos en
// que el markup (no solo el estilo) cambia en móvil — p. ej. los `colSpan` de las tablas de
// asistencia (fix-mobile-responsive, design D1). Sin `matchMedia` (jsdom) → escritorio.
const QUERY = '(max-width: 767px)'

function getMatches(): boolean {
  return typeof window !== 'undefined' && typeof window.matchMedia === 'function' && window.matchMedia(QUERY).matches
}

export function useIsMobile(): boolean {
  const [isMobile, setIsMobile] = useState(getMatches)

  useEffect(() => {
    if (typeof window.matchMedia !== 'function') return
    const mql = window.matchMedia(QUERY)
    const onChange = () => setIsMobile(mql.matches)
    onChange()
    mql.addEventListener('change', onChange)
    return () => mql.removeEventListener('change', onChange)
  }, [])

  return isMobile
}
